import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Heart, Home, Search } from '../icons';
import { useLanguage } from '../context/LanguageContext';

/**
 * 404 page — single source of truth for unknown routes.
 * Sets a noindex meta tag so Google doesn't index garbage URLs (the SPA can't
 * return a true HTTP 404, but this is the next best thing for crawlers).
 */
export default function NotFound() {
  const { t } = useLanguage();
  useEffect(() => {
    // Inject noindex hint for any crawler that ran our JS
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    const prevTitle = document.title;
    document.title = 'Page not found · NepWed';
    return () => {
      document.head.removeChild(meta);
      document.title = prevTitle;
    };
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '70vh',
        padding: '40px 20px',
        textAlign: 'center',
      }}
    >
      <Heart size={64} style={{ color: '#DC143C', marginBottom: 16 }} />
      <div style={{ fontFamily: 'serif', fontSize: 72, fontWeight: 700, color: '#111827', lineHeight: 1, marginBottom: 8 }}>404</div>
      <h1 style={{ fontSize: 24, color: '#111827', margin: '0 0 8px' }}>{t('notFound.title')}</h1>
      <p style={{ color: '#6b7280', maxWidth: 480, lineHeight: 1.6, marginTop: 0 }}>
        {t('notFound.desc')}
      </p>
      <div style={{ display: 'flex', gap: 12, marginTop: 24, flexWrap: 'wrap', justifyContent: 'center' }}>
        <Link
          to="/"
          className="btn btn-primary"
          style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}
        >
          <Home size={16} /> {t('notFound.goHome')}
        </Link>
        <Link
          to="/vendors"
          className="btn btn-outline"
          style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}
        >
          <Search size={16} /> {t('footer.browseVendors')}
        </Link>
      </div>
    </div>
  );
}
